import styled from '@emotion/styled';

export const Container = styled.main`
	display: flex;
	flex-direction: column;
	gap: 8rem;
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
	padding: 8rem 0;
	@media screen and (max-width: 900px) {
		padding: 8rem 2rem;
	}
`;
export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4rem;
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
	&.center {
		justify-content: center;
		align-items: center;
	}
`;
export const ContentItems = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.6rem;
	width: 100%;
	margin: 0 auto;
`;
export const ImgBox = styled.div`
	width: 34.2rem;
	img {
		width: 100%;
	}
`;
export const ContentDescription = styled.p`
	color: var(--Colors-Font---color-font-darker, #212529);
	font-size: 1.8rem;
	font-style: normal;
	font-weight: 400;
	line-height: 140%;
	letter-spacing: -0.6px;
`;
